/** @format */

import {
  DAY_MIN,
  PLANNING_DEFAULT_START,
  getDayS,
  setPlanningDayWindow,
} from './constants';
import {
  normalizePlanningStartConfig,
  resolvePlanningDefaultStart,
} from './planningStartHours';
import { t2m } from './time';

/** In-memory start-hour template, synced from PlanningConfig. */
let cachedConfig = normalizePlanningStartConfig(null);
/** Hour for the week currently shown in the planning (HH:MM). */
let cachedActiveStart = PLANNING_DEFAULT_START;

export function setCachedPlanningStartConfig(config) {
  cachedConfig = normalizePlanningStartConfig(config);
}

export function setPlanningDefaultStart(value) {
  const text = String(value ?? '').trim();
  cachedActiveStart = text || cachedConfig.defaultStart || PLANNING_DEFAULT_START;
  const minutes = t2m(cachedActiveStart);
  if (Number.isFinite(minutes)) setPlanningDayWindow(minutes);
}

/**
 * Default first-slot start (HH:MM).
 * A date (Date or YYYY-MM-DD) resolves that day's ISO week; otherwise the viewed week.
 */
export function getPlanningDefaultStart(date) {
  if (date) return resolvePlanningDefaultStart(cachedConfig, date);
  return cachedActiveStart || cachedConfig.defaultStart || PLANNING_DEFAULT_START;
}

function clampDayStart(minutes) {
  if (!Number.isFinite(minutes)) return getDayS();
  const maxStart = 24 * 60 - DAY_MIN;
  return Math.max(0, Math.min(minutes, maxStart));
}

/** Start of the 10-hour day cell for a date's ISO week. */
export function planningDayStartMin(date) {
  const configured = t2m(
    getPlanningDefaultStart(date) || PLANNING_DEFAULT_START,
  );
  return clampDayStart(configured);
}

/** End of the 10-hour day cell for a date's ISO week. */
export function planningDayEndMin(date) {
  return planningDayStartMin(date) + DAY_MIN;
}
